export default "__VITE_ASSET__b1724efa__"